import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { randFloat } from 'three/src/math/MathUtils';

let scene, camera, renderer, objects = [];

export function initThree(containerId) {
  scene = new THREE.Scene();
  camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);

  renderer = new THREE.WebGLRenderer({ alpha: true });
  renderer.setSize(window.innerWidth, window.innerHeight);
  document.getElementById(containerId).appendChild(renderer.domElement);

  camera.position.z = 6; 
  scene.background = null;

  const ambientLight = new THREE.AmbientLight("#ffffff", 8);
  scene.add(ambientLight);

  const dLoader = new DRACOLoader();
  dLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.7/');
  dLoader.setDecoderConfig({type: 'js'});

  const loader = new GLTFLoader();
  loader.setDRACOLoader(dLoader);

  function addObjectToScene(modelPath, position, rotation, scale, tab) {
    const tryLoadWithFullPath = () => {
      loader.load(modelPath, function (gltf) {
        const object = gltf.scene;
        object.position.copy(position);
        object.rotation.y += rotation.y;
        object.rotation.x += rotation.x;
        object.rotation.z += rotation.z;
        object.scale.copy(scale);
        scene.add(object);
        tab.push(object);
      }, undefined, function (error) {
        console.warn(`Failed to load model with full path: ${modelPath}. Trying with a relative path.${error}`);
        const relativePath = modelPath.substring(modelPath.indexOf('assets'));
        loader.load(relativePath, function (gltf) {
          const object = gltf.scene;
          object.position.copy(position);
          object.rotation.y += rotation.y;
          object.rotation.x += rotation.x;
          object.rotation.z += rotation.z;
          object.scale.copy(scale);
          scene.add(object);
          tab.push(object);
        }, undefined, function (error) {
          console.error(error);
        });
      });
    };
    tryLoadWithFullPath(); 
  }

  const randomX = randFloat(-8, 8);
  const randomY = randFloat(-2.5, 2.5);
  
  //const randomScaleTulipe = randFloat(3, 6);
  //addObjectToScene('HomePage/3d/tulipes.glb', new THREE.Vector3(randomX, randomY, 0), new THREE.Vector3(0, 0, 0), new THREE.Vector3(randomScaleTulipe, randomScaleTulipe, randomScaleTulipe), objects);
  
  const randomScaleStar = randFloat(0.3, 0.8);
  addObjectToScene('HomePage/3d/star.glb', new THREE.Vector3(randomX, randomY, 0), new THREE.Vector3(0, 0, 0), new THREE.Vector3(randomScaleStar, randomScaleStar, randomScaleStar), objects);
  

  function handleResize() {
    const newWidth = window.innerWidth;
    const newHeight = window.innerHeight;
    camera.aspect = newWidth / newHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(newWidth, newHeight);
  }

  window.addEventListener('resize', handleResize);

  const rotationSpeed = 0.005; 

  function animate() {
    requestAnimationFrame(animate);
    objects.forEach(object => {
      object.rotation.y += rotationSpeed;
    });
    renderer.render(scene, camera);
  }

  animate();
}